import React from "react";
import { Script } from "gatsby";
import { isBrowser } from "@app/utils";
import { EventTitle } from "./components/event-title/EventTitle";
import { EventDescription } from "./components/event-description/EventDescription";
import { EventDetails } from "./components/event-details/EventDetails";

type Props = {
  content: string;
  date: string;
  eventId: string;
  title: string;
  subtitle: string;
  summary: string;
  image: string;
  btn1: string;
  btn2: string;
};

export const Event: React.FC<Props> = ({
  content,
  eventId,
  title,
  subtitle,
  summary,
  image,
  btn1,
  btn2,
}) => {
  const handleHeroButton = () => {
    if (!isBrowser()) {
      return;
    }

    const button = document.createElement("button");

    button.setAttribute("id", "eb-button");
    button.setAttribute("type", "button");
    document.body.appendChild(button);
    button.style.display = "none";

    window.EBWidgets?.createWidget({
      widgetType: "checkout",
      eventId: eventId,
      modal: true,
      modalTriggerElementId: "eb-button",
    });

    button.click();
    document.body.removeChild(button);
  };

  const parsedContent = JSON.parse(content);

  return (
    <>
      <Script src="https://www.eventbrite.ch/static/widgets/eb_widgets.js" />
      <EventTitle
        title={title}
        subtitle={subtitle}
        image={image}
        btn1={btn1}
        handleHeroButton={handleHeroButton}
        mediaOptions={parsedContent.mediaOptions}
      />
      <EventDescription
        summary={summary}
        btn2={btn2}
        handleHeroButton={handleHeroButton}
      />
      <EventDetails content={content} />
    </>
  );
};
